import { Button } from '@mui/material'
import GuigotvLogin from 'components/Providers/Guigotv/LoginForm'
import RecoveryPassword from 'components/Providers/Guigotv/RecoveryPassword'
import { useThemeStore } from 'contexts/ThemeStore'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { Content, Footer, FormContent, Header, HeaderImg, Img, Login } from './styled'

function GuigotvAuth() {
  const { usernameOfPartner } = useParams()
  const styledTheme = useTheme()
  const { theme, switchTheme } = useThemeStore()
  const [isrecoveryPassword, setIsrecoveryPassword] = useState(false)

  useEffect(() => {
    switch (usernameOfPartner) {
      case 'barinet':
        if (theme.type !== 'barinet') switchTheme('barinet')
        break
      case 'housenet':
        if (theme.type !== 'housenet') switchTheme('housenet')
        break
      case 'livetv':
        if (theme.type !== 'livetv') switchTheme('livetv')
        break
      case 'msfibra':
        if (theme.type !== 'msfibra') switchTheme('msfibra')
        break
      case 'turbolink':
        if (theme.type !== 'turbolink') switchTheme('turbolink')
        break
      case 'webfiber':
        if (theme.type !== 'webfiber') switchTheme('webfiber')
        break
      default:
        if (theme.type !== 'guigotv') switchTheme('guigotv')
        break
    }
  }, [])

  return (
    <Content>
      <Login>
        <Header>
          <HeaderImg>
            <Img src={styledTheme.imgForm} alt='Parceiros pós-pago' />
          </HeaderImg>
        </Header>
        <FormContent>{isrecoveryPassword ? <RecoveryPassword /> : <GuigotvLogin />}</FormContent>
        <Footer>
          {!isrecoveryPassword && (
            <Button style={{ textDecoration: 'underline', fontSize: '14px', textTransform: 'none' }} onClick={() => setIsrecoveryPassword(true)}>
              Esqueceu a senha?
            </Button>
          )}
        </Footer>
      </Login>
    </Content>
  )
}

export default GuigotvAuth
